import React from 'react'

const MobileFiltersPrice = () => {
	return (
		<div>
			<div>
				<div className='mb-3'>
					<h5 className='text-normal text-black'>Price</h5>
				</div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Below Rs.500 <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Below Rs.500 - 1000 <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Below Rs.1001 - 1500 <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Below Rs.1501 - 2000 <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Below Rs.2001 - 3000 <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Below Rs.3001 - 5000 <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Above Rs.5000 <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<h6 className='text-bold text-black'>Price Range</h6>
			<div className='d-flex mt-3 mb-3 justify-content-center align-items-center gap-2'>
				<div>
					<div className=' input-group input-group-outline input-group-lg'>
						<input type='text' className='form-control' placeholder='Min' />
					</div>
				</div>
				<div>-</div>
				<div>
					<div className=' input-group input-group-outline input-group-lg'>
						<input type='text' className='form-control' placeholder='Max' />
					</div>
				</div>
			</div>
			<div>
				<button className='btn btn-dark btn-md w-100'>Done</button>
			</div>
		</div>
	)
}

export default MobileFiltersPrice
